import { render, staticRenderFns } from "./PageCategoryForm.vue?vue&type=template&id=e988a66c&scoped=true&"
import script from "./PageCategoryForm.vue?vue&type=script&lang=js&"
export * from "./PageCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./PageCategoryForm.vue?vue&type=style&index=0&id=e988a66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e988a66c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardSubtitle,VCardTitle})
